/**
*****************************************
*										                    *
* NAGARRO  - CSX - CONFIDENTIAL         *
*										                    *
*****************************************
*/
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ConfigService } from '../../../core/services/config.service';
import { TrainData } from '../../../core/model/train-data.model';

/**
 * @export
 * @class LmsTrainInformationComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-train-information',
  templateUrl: './lms-train-information.component.html',
  styleUrls: ['./lms-train-information.component.scss']
})
export class LmsTrainInformationComponent implements OnInit, OnDestroy {

  @Input() trainData: TrainData;
  trainLabel: any;

  /**
   * Creates an instance of LmsTrainInformationComponent.
   * @param {ConfigService} configService
   * @memberOf LmsTrainInformationComponent
   */
  constructor(private configService: ConfigService) {
    this.trainLabel = this.configService.getConfigData().trainLabel;
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LmsTrainInformationComponent
   */
  ngOnInit() {
  }

  /**
   * Clean the state of lifecycle hook.
   * @memberOf LmsTrainInformationComponent
   */
  ngOnDestroy() {
  }

  /**
   * check value and return dash.
   * @param {string[]} value
   * @returns
   * @memberOf LmsTrainInformationComponent
   */
  returnDash(value: string[]) {
    let isBlank: boolean;
    for (let i = 0; i < value.length; i++) {
      if (value[i]) {
        isBlank = false;
        break;
      } else {
        isBlank = true;
      }
    }
    return isBlank;
  }

}
